"use client"

import { useEffect, useState } from "react"
import type { BlogArticle } from "@/content/blog-shared"
import { ArticleCard, BLOG_SAVED_KEY } from "./article-card"
import styles from "./article.module.css"

export function RelatedArticleCards({ articles }: { articles: BlogArticle[] }) {
  const [saved, setSaved] = useState<string[]>([])
  const [ready, setReady] = useState(false)
  const [notice, setNotice] = useState("")

  useEffect(() => {
    try {
      const value: unknown = JSON.parse(localStorage.getItem(BLOG_SAVED_KEY) || "[]")
      if (Array.isArray(value)) setSaved(value.filter((slug): slug is string => typeof slug === "string"))
    } catch { /* Bookmarks remain available for this visit if storage is disabled. */ }
    setReady(true)
  }, [])

  function toggleSave(article: BlogArticle) {
    const alreadySaved = saved.includes(article.slug)
    const next = alreadySaved ? saved.filter(slug => slug !== article.slug) : [...saved, article.slug]
    setSaved(next)
    try { localStorage.setItem(BLOG_SAVED_KEY, JSON.stringify(next)) }
    catch { /* Keep the in-memory reading list when storage is unavailable. */ }
    setNotice(alreadySaved ? "Article removed from your reading list." : "Article saved to your reading list on this device.")
  }

  return <>
    <div className={styles.relatedGrid}>{articles.map(article => <ArticleCard key={article.slug} article={article} ready={ready} saved={saved.includes(article.slug)} onSave={() => toggleSave(article)} />)}</div>
    <p className="sr-only" role="status" aria-live="polite">{notice}</p>
  </>
}
